import { render, staticRenderFns } from "./GenerateForm.vue?vue&type=template&id=c8c8b350&"
import script from "./GenerateForm.vue?vue&type=script&lang=js&"
export * from "./GenerateForm.vue?vue&type=script&lang=js&"
import style0 from "./GenerateForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports